import { render, staticRenderFns } from "./PortfolioIcon.vue?vue&type=template&id=0a2296d6&scoped=true&"
import script from "./PortfolioIcon.vue?vue&type=script&lang=js&"
export * from "./PortfolioIcon.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioIcon.vue?vue&type=style&index=0&id=0a2296d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2296d6",
  null
  
)

export default component.exports